import { InternalAxiosRequestConfig } from 'axios';
import { authService } from 'pages/auth/authService';
import dayjs from 'dayjs';
import { AuthToken } from 'pages/auth/authModels';

const setAuthHeader = ({
  config,
  token,
}: {
  config: InternalAxiosRequestConfig<any>;
  token: AuthToken;
}) => {
  if (config.headers) {
    config.headers['Authorization'] = `Bearer ${token.access_token}`;
  }

  return config;
};

export const axiosTokenInterceptor = async (
  config: InternalAxiosRequestConfig
) => {
  const token = authService.getTokenFromStorage();

  try {
    if (dayjs().isAfter(token?.expires_at)) {
      const newToken = await authService.refreshToken();
      authService.saveTokenToStorageAndQuery(newToken);
      return setAuthHeader({ config, token: newToken });
    } else {
      return token ? setAuthHeader({ config, token }) : config;
    }
  } catch {
    return config;
  }
};
